// extracted by mini-css-extract-plugin
module.exports = {"root":"ZMo64","bg":"_2DSFf","i":"_1MyuO","b":"_2gZz7","l":"_580ty","r":"Bc-tE"};